import { useId, useState } from 'react'
import { Props_SnippetVideoCarousel } from './VideoCarousel.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import { convertIframeUrl } from '../Video/Video'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, A11y } from 'swiper/modules'
import SwiperControls, { swiperNavigationOptions } from '../Shared/SwiperControls/SwiperControls'

const classBase: string = 'snippet-video-carousel'

export const SnippetVideoCarousel = (props: Props_SnippetVideoCarousel) => {
    const id = useId()
    const { heading, repeatable_entry } = props

    const uniqueId = useId().replace(/[^a-zA-Z0-9-_]/g, '')
    const carouselId = `snippet-video-carousel-${uniqueId}`

    const classHeadingVisibility: string = heading.visibility.value ? `${classBase}__heading--${heading.visibility.value}` : ''

    return (
        <section className="snippet-video-carousel">
            <div className={`snippet-video-carousel__container`}>
                <h2 className={`snippet-video-carousel__heading ${classHeadingVisibility}`}>{ heading.content.value }</h2>
                <div className="snippet-video-carousel__container-entries">
                    <Swiper
                        modules={[Navigation, Pagination, A11y]}
                        spaceBetween={20}
                        slidesPerView={'auto'}
                        freeMode={true}
                        watchOverflow={true}
                        watchSlidesProgress={true}
                        grabCursor={true}
                        navigation={{
                            ...swiperNavigationOptions,
                            prevEl: `.swiper-navigation__button-prev-${carouselId}`,
                            nextEl: `.swiper-navigation__button-next-${carouselId}`,
                        }}
                        className="snippet-video-carousel__swiper"
                    >
                        { repeatable_entry.map((entry, index: number) => {
                            const [playing, setPlaying] = useState(false)
                            const classVideoPlaying: string = playing ? `${classBase}__entry-media-container--playing` : ''

                            return (
                            <SwiperSlide key={`snippet-video-carousel__entry-${id}-${index}`}>
                                <div id={id} key={`snippet-video-carousel__entry-${id}-${index}`} className={`snippet-video-carousel__entry snippet-video-carousel__entry--theme-${entry.theme?.value}`}>
                                    <div className="snippet-video-carousel__entry-content-container">
                                        { entry.content?.value && <div className="snippet-video-carousel__entry-content">{ Legacy_CompileMarkdown(entry.content.value) }</div> }
                                    </div>
                                    { entry.image?.value && (
                                        <figure className={`snippet-video-carousel__entry-media-container ${classVideoPlaying}`}>
                                            <img
                                                className="snippet-video-carousel__entry-image"
                                                loading="lazy"
                                                height={375}
                                                width={200}
                                                src={entry.image.value}
                                                alt={entry.alt?.value ? entry.alt.value : ''}
                                            />
                                            { entry.video?.value && (
                                                <>
                                                    <button className="snippet-video-carousel__entry-video-button play-button" aria-label={`{{js.snippet.content-column.video.play-button.aria-label}}`} onClick={() => setPlaying(true)}>
                                                        <span className="play-button__icon"></span>
                                                        <span className="play-button__text">{`{{js.snippet.content-column.video.play-button.label}}`}</span>
                                                    </button>
                                                    <iframe
                                                        width="200"
                                                        height="375"
                                                        src={playing && entry.video?.value ? convertIframeUrl(entry.video.value) : ''}
                                                        title="YouTube video player"
                                                        loading="lazy"
                                                        allow="accelerometer autoplay clipboard-write encrypted-media gyroscope picture-in-picture web-share"
                                                        referrerPolicy="strict-origin-when-cross-origin"
                                                        className="snippet-video-carousel__entry-video"
                                                        allowFullScreen={true}
                                                    ></iframe>
                                                </>
                                            )}
                                        </figure>
                                    )}
                                </div>
                            </SwiperSlide>
                        )})}
                    </Swiper>
                    <SwiperControls 
                        id={carouselId}
                        showNavigationPrev={true}
                        showNavigationNext={true}
                        showPagination={false}
                        className="snippet-video-carousel__swiper-controls"
                    />
                </div>
            </div>
        </section>
    )
}

export default SnippetVideoCarousel